<template>
	<Dropdown position="bottom-start">
		<template #trigger>
			<button
				v-bind="$attrs"
				type="button"
				class="w-10 h-10 bg-none rounded-full shrink-0 hover:ring ring-base-200 border border-gray-300 overflow-hidden relative flex items-center justify-center"
				:style="isNoColor ? {} : { backgroundColor: modelValue }"
				data-testid="trigger-color-button"
			>
				<!-- show SVG only if no color is selected -->
				<svg
					v-if="isNoColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 5 5"
					class="absolute inset-0 w-full h-full opacity-70 text-gray-400"
					preserveAspectRatio="none"
				>
					<rect width="5" height="5" fill="currentColor" />
					<path
						d="M0,0V5H1V0zM2,0V5H3V0zM4,0V5H5V0zM0,0H5V1H0zM0,2H5V3H0zM0,4H5V5H0z"
						fill="#fff"
						fill-rule="evenodd"
					/>
				</svg>
			</button>
		</template>
		<template #content>
			<div class="w-64 bg-base rounded-lg shadow-lg p-4">
				<!-- 8 colors, grid of 32 swatches of Tailwind colors -->
				<div class="grid grid-cols-4 gap-1">
					<template v-for="color in getColors()">
						<button type="button" data-testid="content-color-button" class="w-12 h-6 rounded shrink-0 hover:scale-110 transition-all" :style="{ backgroundColor: color }" @click="updateValue(color)"></button>
					</template>
				</div>
			</div>
		</template>
	</Dropdown>
</template>


<script lang="ts">
import Dropdown from '@/components/ui/Dropdown.vue';

const colorSwatch = [
		'#2563eb', // blue-600
		'#3b82f6', // blue-500
		'#60a5fa', // blue-400
		'#93c5fd', // blue-300
		'#16a34a', // green-600
		'#22c55e', // green-500
		'#4ade80', // green-400
		'#86efac', // green-300
		'#65a30d', // lime-600
		'#84cc16', // lime-500
		'#a3e635', // lime-400
		'#c0f66b', // lime-300
		'#f59e0b', // yellow-600
		'#fbbf24', // yellow-500
		'#fcd34d', // yellow-400
		'#fde68a', // yellow-300
		'#ea580c', // orange-600
		'#f97316', // orange-500
		'#fb923c', // orange-400
		'#f9ac64', // orange-300
		'#dc2626', // red-600
		'#ef4444', // red-500
		'#f87171', // red-400
		'#fbb6b9', // red-300
		'#db2777', // pink-600
		'#ec4899', // pink-500
		'#f472b6', // pink-400
		'#f9a8d4', // pink-300
		'#7c3aed', // purple-600
		'#9333ea', // purple-500
		'#ae3afc', // purple-400
		'#d4aaff', // purple-300
	];

export default {
	inheritAttrs: false,

	emits: ['update:modelValue'],

	props: {
		modelValue: {
			type: String,	// hex color
			required: true,
		},
	},

	components: {
		Dropdown,
	},

	computed: {
		isNoColor(): boolean {
			return !this.modelValue || !/^#[0-9a-f]{6}$/i.test(this.modelValue);
		}
	},

	methods: {
		updateValue(color) {
			if (color) {
				this.$emit('update:modelValue', color)
			}
		},

		getColors() {
			return colorSwatch;
		}
	}
}
</script>
